import Icon from './Icon'
import { useEffect, useState } from 'react'
import { useTrans } from 'hooks'
import { useRouter } from 'next/router'

const Credits = props => {
  const {
    label = 'Crediti',
    crediti = null,
    children,
    classes = '',
    variant = 'default',
    icon = null,
    initialOpen = false,
    href = '',
  } = props

  const t = useTrans()

  const router = useRouter()

  const [open, setOpen] = useState(initialOpen)

  const handleToggle = () => {
    if (!open && href) {
      router.push(`${router.asPath.split('#')[0]}${href}`)
    }
    setOpen(!open)
  }

  useEffect(() => {
    if (initialOpen) initOpen()
  }, [initialOpen])

  function initOpen() {
    setOpen(initialOpen)
  }

  return (
    <div className={`credits ${classes} credits--${variant} ${open ? 'credits--open' : ''}`}>
      <p className="credits__trigger" onClick={handleToggle}>
        {t(label)} {icon ? icon : <Icon id="chevron-sharp-right" />}
      </p>
      <div className="credits__content">
        {crediti}
        {children}
      </div>
    </div>
  )
}

export default Credits
